import { cn } from '../../../shared/lib/cn';

export const BuiltinTag = ({ className }: { className?: string }) => (
  <span
    className={cn(
      'inline-flex h-5 shrink-0 items-center rounded-tag bg-chip-on px-label',
      'text-micro font-medium text-muted',
      className,
    )}
  >
    built in
  </span>
);
